import type { AppRouteObject } from "../routes";
import { ExportRoute } from "./routes/ExportRoute";

const routes: AppRouteObject[] = [ExportRoute];

export default routes;
